export const capitalize = (input) => {
    if (!input)
        return '';
    try {
        return input
            .toLowerCase()
            .replace(/(^|\s)\S/g, letter => letter.toUpperCase());
    }
    catch (error) {
        console.error('Error capitalizing string:', error);
        return String(input);
    }
};
